const STORAGE_KEY = 'at_wishlist';

function getItems() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
  catch { return []; }
}

function saveItems(items) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  updateBadge();
  updateDrawerIfOpen();
}

function toggle(data) {
  const items = getItems();
  const idx = items.findIndex(i => i.id === data.id);
  if (idx > -1) {
    items.splice(idx, 1);
    saveItems(items);
    return false;
  }
  items.push(data);
  saveItems(items);
  return true;
}

function isLiked(id) {
  return getItems().some(i => i.id === String(id));
}

function updateBadge() {
  const count = getItems().length;
  document.querySelectorAll('.wishlist-header-badge').forEach(badge => {
    badge.textContent = count > 0 ? count : '';
    badge.style.display = count > 0 ? 'flex' : 'none';
  });
}

function renderDrawerItems() {
  const items = getItems();
  if (items.length === 0) {
    return '<p class="wishlist-drawer__empty">No saved items yet.</p>';
  }
  return items.map(item => `
    <div class="wishlist-item" data-id="${item.id}">
      <a href="${item.url}" class="wishlist-item__image-link">
        ${item.image
          ? `<img src="${item.image}" alt="${item.title}" class="wishlist-item__image" loading="lazy">`
          : `<div class="wishlist-item__image" style="background:var(--color-border)"></div>`
        }
      </a>
      <div class="wishlist-item__info">
        <a href="${item.url}" class="wishlist-item__title">${item.title}</a>
        <p class="wishlist-item__price">${item.price}</p>
      </div>
      <button class="wishlist-item__remove" data-id="${item.id}" aria-label="Remove ${item.title}">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
  `).join('');
}

function updateDrawerIfOpen() {
  const drawer = document.getElementById('wishlist-drawer');
  if (!drawer || !drawer.open) return;
  const body = drawer.querySelector('.wishlist-drawer__body');
  if (body) body.innerHTML = renderDrawerItems();
  bindRemoveButtons();
}

function bindRemoveButtons() {
  document.querySelectorAll('.wishlist-item__remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.id;
      const items = getItems().filter(i => i.id !== id);
      saveItems(items);
      document.querySelectorAll(`.product-wishlist-btn[data-product-id="${id}"]`).forEach(b => {
        b.classList.remove('product-wishlist-btn--active');
      });
    });
  });
}

function openDrawer() {
  const drawer = document.getElementById('wishlist-drawer');
  if (!drawer) return;
  const body = drawer.querySelector('.wishlist-drawer__body');
  if (body) body.innerHTML = renderDrawerItems();
  bindRemoveButtons();
  drawer.showModal();
}

function initDrawer() {
  if (document.getElementById('wishlist-drawer')) return;
  const drawer = document.createElement('dialog');
  drawer.id = 'wishlist-drawer';
  drawer.className = 'wishlist-drawer';
  drawer.innerHTML = `
    <div class="wishlist-drawer__header">
      <h2 class="wishlist-drawer__title">Saved Items</h2>
      <button class="wishlist-drawer__close button-unstyled" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
    <div class="wishlist-drawer__body"></div>
  `;
  document.body.appendChild(drawer);
  drawer.querySelector('.wishlist-drawer__close').addEventListener('click', () => drawer.close());
  drawer.addEventListener('click', e => { if (e.target === drawer) drawer.close(); });
}

function initButtons() {
  document.querySelectorAll('.product-wishlist-btn').forEach(btn => {
    const id = btn.dataset.productId;
    if (!id) return;

    if (isLiked(id)) btn.classList.add('product-wishlist-btn--active');

    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const data = {
        id: btn.dataset.productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || '',
        url: btn.dataset.productUrl || `/products/${btn.dataset.productHandle}`,
      };
      const added = toggle(data);
      btn.classList.toggle('product-wishlist-btn--active', added);
    });
  });
}

function initHeaderButtons() {
  document.querySelectorAll('.wishlist-header-btn').forEach(btn => {
    btn.addEventListener('click', openDrawer);
  });
}

function initProductListArrows() {
  const section = document.querySelector('.ui-test-product-list');
  if (!section) return;
  const prevBtn = section.querySelector('.slideshow-control--previous');
  const nextBtn = section.querySelector('.slideshow-control--next');
  const innerHeader = section.querySelector('.section-resource-list__header .group-block-content');
  if (!prevBtn || !nextBtn || !innerHeader) return;

  function makeArrow(label, icon) {
    const btn = document.createElement('button');
    btn.setAttribute('aria-label', label);
    btn.innerHTML = icon;
    btn.style.cssText = 'background:none;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;color:inherit;flex-shrink:0;';
    return btn;
  }

  const prev = makeArrow('Previous', '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>');
  const next = makeArrow('Next', '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>');

  const scroller = section.querySelector('slideshow-slides');

  function scrollCarousel(direction) {
    if (scroller) {
      const card = scroller.querySelector('.resource-list__slide');
      const amount = card ? card.offsetWidth + parseInt(getComputedStyle(scroller).gap || 0) : 300;
      scroller.scrollBy({ left: direction * amount, behavior: 'smooth' });
    } else {
      direction > 0 ? nextBtn.click() : prevBtn.click();
    }
  }

  prev.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); scrollCarousel(-1); });
  next.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); scrollCarousel(1); });

  const heading = innerHeader.querySelector('h1,h2,h3,h4,h5,h6');
  if (heading) heading.style.whiteSpace = 'nowrap';

  const children = Array.from(innerHeader.children);
  const viewAllEl = children[children.length - 1];
  const viewAllLink = viewAllEl ? viewAllEl.querySelector('a') : null;

  const viewAllClone = document.createElement('a');
  viewAllClone.textContent = viewAllLink ? viewAllLink.textContent.trim() : 'View all';
  viewAllClone.href = viewAllLink ? viewAllLink.href : '/collections/all';
  viewAllClone.style.cssText = 'color:inherit;text-decoration:none;font-size:inherit;white-space:nowrap;';
  if (viewAllEl) viewAllEl.style.display = 'none';

  innerHeader.style.justifyContent = 'space-between';

  const arrowGroup = document.createElement('div');
  arrowGroup.style.cssText = 'display:flex;align-items:center;gap:12px;';
  arrowGroup.appendChild(viewAllClone);
  arrowGroup.appendChild(prev);
  arrowGroup.appendChild(next);

  innerHeader.appendChild(arrowGroup);
}



function initOurCollectionHeading() {
  const section = document.getElementById('shopify-section-product_list_favourites');
  if (!section) return;
  const header = section.querySelector('.section-resource-list__header');
  const target = header || section;
  target.querySelectorAll('h2, h3, h4, .text-block').forEach(el => {
    el.style.setProperty('font-size', 'var(--font-h2--size)', 'important');
    el.style.setProperty('font-family', 'var(--font-h2--family)', 'important');
    el.style.setProperty('font-weight', 'var(--font-h2--weight)', 'important');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initDrawer();
  initButtons();
  initHeaderButtons();
  updateBadge();
  initProductListArrows();

  initOurCollectionHeading();
});
